import type { LoaderFunctionArgs } from '@remix-run/node';

import { Form, useLoaderData } from '@remix-run/react';
import { json, redirect } from '@remix-run/node';
import { useTranslation } from 'react-i18next';
import { login } from '~/shopify.server';

export const loader = async ({ request }: LoaderFunctionArgs) => {
  const url = new URL(request.url);

  if (url.searchParams.get('shop')) {
    throw redirect(`/app?${url.searchParams.toString()}`);
  }

  return json({ showForm: Boolean(login) });
};
export default function App() {
  const { t } = useTranslation();
  const { showForm } = useLoaderData<typeof loader>();

  return (
    <div className="index">
      <div className="content">
        <h1>{t('A short heading about [your app]')}</h1>
        <p>{t('A tagline about [your app] that describes your value proposition.')}</p>
        {showForm && (
          <Form method="post" action="/auth/login">
            <label>
              <span>{t('Shop domain')}</span>
              <input type="text" name="shop" />
              <span>{t('e.g: my-shop-domain.myshopify.com')}</span>
            </label>
            <button type="submit">{t('Log in')}</button>
          </Form>
        )}
        <ul>
          <li>
            <strong>{t('Product feature')}</strong>
            {t('. Some detail about your feature and its benefit to your customer.')}
          </li>
          <li>
            <strong>{t('Product feature')}</strong>
            {t('. Some detail about your feature and its benefit to your customer.')}
          </li>
          <li>
            <strong>{t('Product feature')}</strong>
            {t('. Some detail about your feature and its benefit to your customer.')}
          </li>
        </ul>
      </div>
    </div>
  );
}
